import type { Form } from '../../../../common/types/form';
import type { Documentation } from '../../../../common/types/documentation';

import dateHoursFields from '../../../form/dateHoursFields';

const meetingInternForm: Form<Documentation> = {
  key: 'meetingIntern',
  title: 'Intervision',
  fields: [
    ...dateHoursFields,
    {
      key: 'topic',
      label: 'Thema',
      fieldTypes: 'text',
    },
  ],
};

export default meetingInternForm;
